// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__NGiZT","footer":"ModalFilter_footer__9of1z"};